module.exports = __webpack_public_path__ + "static/media/white-search.ed08b470.svg";